import { TFunction } from "i18n";

export interface IYearOption {
  label: string;
  value: number;
}

export interface IGetAgeOptionsParams {
  t: TFunction;
  minAge?: number;
  maxAge?: number;
  selectedFrom?: number | null;
  selectedTo?: number | null;
}

export default function getAgeRangeOptions({
  t,
  minAge = 0,
  maxAge = 99,
  selectedFrom = null,
  selectedTo = null,
}: IGetAgeOptionsParams): {
  yearsFrom: IYearOption[];
  yearsTo: IYearOption[];
} {
  const allAges = Array.from(
    { length: maxAge - minAge + 1 },
    (_, i) => i + minAge
  );

  const formatLabel = (age: number): string => {
    if (age === 0) {
      return t("common:label.options.playingAge.month", { count: 6 });
    }

    return t("common:label.options.playingAge.year", { count: age });
  };

  const getYearOption = (age: number) => ({
    label: formatLabel(age),
    value: age,
  });

  const yearsFrom = allAges
    .filter((age) => selectedTo === null || age <= selectedTo)
    .map(getYearOption);

  const yearsTo = allAges
    .filter((age) => selectedFrom === null || age >= selectedFrom)
    .map(getYearOption);

  return { yearsFrom, yearsTo };
}
